'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _module = angular.module('cb.strips.cbStripFunnelV1', []);

_module.directive('cbStripFunnelV1', cbStripFunnelV1);

exports.default = _module;


function cbStripFunnelV1() {
    var version = 1.00;

    return {
        restrict: 'A',
        link: cbStripFunnelV1Link
    };

    function cbStripFunnelV1Link(scope, element, attr) {}
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/funnel-v1/funnel.directive.js
// module id = 942
// module chunks = 1